import styled from 'styled-components';

export const Empty = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-top: 40px;

    @media (min-width: 76.25em) {
        flex-direction: row;

        h1{
            font-size: 1.3em;
        }
    }

    @media (min-width: 90.5em) {
        h1{
            font-size: 1.6em;
        }
    }
    
    h1{
        margin: 0 10px;
        color: #ccc;
    }
`;

export const Item = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    background-color: var(--white);
    font-size: 0.8em;
    flex-direction: column;

    @media (min-width: 37.5em) {
        flex-direction: row;    
    }   
   
    .svg{
        border-radius: 40px;
        padding: 10px;
        width: 40px;
        height: 40px;

        &:hover{
            background-color: #ededed;            
        }
    }

    &:last-of-type{
        margin-bottom: 0;
    }
`;

export const Image = styled.div`
    width: 180px;
    height: 180px;
    overflow: hidden;
    background-color: #ededed;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    color: #ccc;
    position: relative;
    border: 1px solid #ededed;

    img{
        max-width: inherit;
        width: auto;
        height: 100%;
    }

    .count{
        position: absolute;
        top: 0;
        left: 0;
        padding: 3px 10px;
        background-color: #000;
    }

    .capa{
        position: absolute;
        top: 0;
        left: 0;
        width: 180px;
        height: 180px;
        transition: 0.5s opacity;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        cursor: pointer;
        background-color: rgba(0,0,0,0.5);
        opacity: 0;

        &.capa-hover{
            opacity: 1;
        }
    }

    &:hover .capa{
        opacity: 1;
    }
`;

export const DsFlex = styled.div`
    display: flex;

    & > div{
        flex:1;
        margin-right: 10px;

        &:last-of-type{
            margin-right: 0;
        }
    }
`;

export const Upload = styled.input`
    width: 1px;
    height: 1px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
    opacity: 0;    
    cursor: pointer;
`;

export const ContainerItem = styled.div`
    margin-top: 10px;
`;

export const ItemInfo = styled.div`
    padding: 10px 0;
    margin: 0 30px;
    flex-direction: column;
    
    & > div{
        margin-bottom: 10px;
        text-align: center;
    }

    @media (min-width: 37.5em) {
        flex-direction: row;

        & > div{
            margin-bottom: 0;
            margin-right: 20px;
            text-align: left;
        }
    }       
`;

export const Document = styled.div`
    background-color: #fff;
    padding: 5px;
    display: flex;
    overflow: auto;
    font-size: 0.8em;

    & > div{
        padding: 0 30px;
        border-right: 1px solid #ededed;
        
        &:first-of-type{
            padding-left: 0%;
        }

        &:last-of-type{
            border-right: 0;
        }
    }
`;

export const CroppieI = styled.div`
    padding: 1rem 0rem;
    margin-bottom: 1rem;

    .hidden{
        display: none;
    }

    .show{
        display: block;
    }

    #image-helper {
        background-color: #eeeeee;
        margin-top: 1rem;
        margin-bottom: 1rem;
        border: 1px dashed #3f51b5;
        padding-top: 1rem;
    }
`;

export const LabelI = styled.label`
    cursor: pointer;
    line-height: normal;
`;